var id = window.location.pathname.split('/')[1];
$.get(window.location.origin.concat('/analytics/', id));
